webpackJsonp([248590598229537],{

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SEO = __webpack_require__(21);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _pageModule = __webpack_require__(35);
	
	var _pageModule2 = _interopRequireDefault(_pageModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var data = _ref.data;
	
	  var episode = data.rssFeedItem;
	  return _react2.default.createElement(
	    "div",
	    { className: _pageModule2.default.container },
	    _react2.default.createElement(_SEO2.default, {
	      title: episode.title,
	      image: episode.itunes.image
	    }),
	    _react2.default.createElement(
	      "h1",
	      null,
	      episode.title
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: _pageModule2.default.date },
	      new Date(episode.pubDate).toLocaleDateString()
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: _pageModule2.default.player },
	      _react2.default.createElement("img", { className: _pageModule2.default.image, src: episode.itunes.image }),
	      _react2.default.createElement("audio", { className: _pageModule2.default.audio, src: episode.enclosure.url, preload: "none", controls: true })
	    ),
	    _react2.default.createElement("div", { className: _pageModule2.default.description, dangerouslySetInnerHTML: { __html: episode.content } })
	  );
	};
	
	var query = exports.query = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-episode-post-js-c211b4009b7d65684fa3.js